import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Profile } from '../../../_common/profile';
import parsePhoneNumber from 'libphonenumber-js';
// import { authenticateUser } from '../../../actions/auth-api';
// import Credentials from '../../../constants/models/credentials';
import * as R from 'ramda';
import countryTelData from 'country-telephone-data';
import {updateOnBoardingStep} from '../../../actions/user-api';

export const Step1 = ({ passwordRequirements, setPasswordRequirements }) => {
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const user = useSelector(state => state.user);
    const history = useHistory();
    const credentialsForm = useRef(null);
    const [wasValidated, setWasValidated] = useState(false);
    const [credentials, setCredentials] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        phoneNumber: '',
        otpCode: '',
        countryCode: '33',
        phoneCountry: 'FR'
    });

    function fillCredentials(){
        let number = undefined;
        let dialCode = undefined;

        if (!R.isNil(user.user) && !R.isNil(user.user.phoneNumber) && user.user.phoneNumber !== '') {
            let tmpPhone = user.user.phoneNumber.slice(1);

            for (let i = 1; i<tmpPhone.length; i++){
                let country = countryTelData.allCountries.find(c => c.dialCode === tmpPhone.slice(0, i));
                if (!R.isNil(country)) {
                    dialCode = country.dialCode;
                    break;
                }
            }
            number = tmpPhone.slice(dialCode.length);
        }
        setCredentials({
            ...credentials, email: !R.isNil(user.user) && !R.isNil(user.user.email) && user.user.email !== '' ? user.user.email : '',
            phoneNumber: !R.isNil(number) ? number.replace(/\B(?=(\d{3})+(?!\d))/g, " ") : '',
            countryCode: !R.isNil(dialCode) ? dialCode : '33'
        });
    }

    useEffect(() => {
        async function redirectToSecondStep() {
            //  await dispatch(authenticateUser(new Credentials({ email: credentials.email, phoneNumber: credentials.countryCode+credentials.phoneNumber.replace(/ /g,''), password: credentials.password })));
            dispatch(updateOnBoardingStep(1));
            history.push("/auth/signup/step2" + (window.location.search !== "" ? window.location.search : ""));
        }
        if (!R.isNil(auth.registered) && auth.registered === true && (R.isNil(user.user) || R.isNil(user.user.phoneNumber) || user.user.phoneNumber === '')) {
            redirectToSecondStep();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.registered]);

    useEffect(() => {
        if(!R.isNil(user.user)){
            const phoneNumber = R.isNil(user.user.phoneNumber) ?  parsePhoneNumber(credentials.phoneNumber, credentials.countryCode) : parsePhoneNumber(user.user.phoneNumber);

            setCredentials({
                ...credentials,
                email: user.user.email,
                phoneNumber: !R.isNil(phoneNumber) ? phoneNumber.nationalNumber : credentials.phoneNumber,
                countryCode: !R.isNil(phoneNumber) ? phoneNumber.countryCallingCode : credentials.countryCode,
            });
        }
    }, [user.user]);

    return (
        <article className="view-calc pt-0 mb-auto">
            <div className="container-fluid">
                <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0">
                    <h1 className="text-primary font-weight-bolder mt-2 mb-3">Créer un compte</h1>
                    <p className="h2 o-50 font-weight-bol ls-n1 mt-n2">Veuillez saisir votre identifiant et créer un mot de passe</p>
                </header>
            </div>
            <Profile passwordRequirements={passwordRequirements} setPasswordRequirements={setPasswordRequirements} registerPage={true}
                credentials={credentials} setCredentials={setCredentials} credentialsForm={credentialsForm} wasValidated={wasValidated}  setWasValidated={setWasValidated}/>
        </article>
    )
}